export default theme => ({
  axis: {
    marginTop: 2,
    stroke: theme.palette.shadow.main,
    overflow: "initial",
    backgroundColor: "rgba(0, 0, 0, 0.05)",
  },
});
